<template>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div
            v-for="(box, index) in boxes"
            :key="index"
            class="flex flex-col gap-2 rounded-md border border-gray-200 p-4"
        >
            <TextField
                v-model="box.label"
                :name="`${namePrefix}_${index}_label`"
                label="campaign_marketing_current_status_box_label"
                help="help_campaign_marketing_current_status_box_label"
            />
            <TextField
                v-model="box.value"
                :name="`${namePrefix}_${index}_value`"
                label="campaign_marketing_current_status_box_value"
                help="help_campaign_marketing_current_status_box_value"
            />
            <TextField
                v-model="box.sublabel"
                :name="`${namePrefix}_${index}_sublabel`"
                label="campaign_marketing_current_status_box_sublabel"
                help="help_campaign_marketing_current_status_box_sublabel"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import TextField from '@src/components/TextField.vue'
import { CampaignCurrentStatusBox } from '@src/types'
import { ref, watch } from 'vue'

const props = defineProps<{
    modelValue: CampaignCurrentStatusBox[] | null
    namePrefix: string
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: CampaignCurrentStatusBox[] | null): void
}>()

function padToThree(
    value: CampaignCurrentStatusBox[] | null
): CampaignCurrentStatusBox[] {
    return Array.from(
        { length: 3 },
        (_, index) => value?.[index] ?? new CampaignCurrentStatusBox()
    )
}

function isBlank(box: CampaignCurrentStatusBox): boolean {
    return !box.label && !box.value && !box.sublabel
}

// Always keep 3 editable rows locally, but only ever emit real data upward
// (null when all 3 are blank) so an untouched form never sends 3 empty
// placeholder objects to the API.
const boxes = ref<CampaignCurrentStatusBox[]>(padToThree(props.modelValue))

watch(
    () => props.modelValue,
    (value) => {
        if (!value || value.length !== 3) {
            boxes.value = padToThree(value)
        }
    }
)

watch(
    boxes,
    (value) => {
        emit('update:modelValue', value.every(isBlank) ? null : value)
    },
    { deep: true }
)
</script>
